'use strict';

// modules which need to be inited
var lazyImage = require('lazy-image');
var customAnalytics = require('custom-analytics');
var backToTop = require('back-to-top');

// app specific js files which need to be inited
var floatingElement = require('./floating-element');
var experts = require('./experts');
var containerLink = require('container-link');
var locationMatcher = require('location-matcher');
var banner = require('./banner');
var productNav = require('./product-nav');

// global modules, use package.json aliases
require('jquery-migrate');
require('velocity');
require('vimeo-analytics');

// app specific modules, use file names
require('./checkout');
require('./featureboxes');
require('./form');
require('./lightbox');
require('./menu');
require('./video');
require('./work');


floatingElement.init();
experts.init();
containerLink.init();
locationMatcher.init();
banner.init();
productNav.init();
backToTop.init();


module.exports = {

	// Expose new browserify modules to legacy js.
	customAnalytics: customAnalytics,
	lazyImage: lazyImage

};
